import { BorderRadius, Color, getShadow, Spacing, zIndex } from '@billy/design-system'
import styled from '@emotion/styled'

export const Popover = styled.div`
  min-width: 240px;
  padding: ${Spacing.S8} 0;
  border-radius: ${BorderRadius.R12};
  position: absolute;
  top: calc(100% + ${Spacing.S8});
  left: 50%;
  z-index: ${zIndex.Dropdown};
  transform: translateX(-50%);
  background-color: ${Color.White};
  ${getShadow('raisedStrong')}
`

export const PopoverItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S12};
  padding: ${Spacing.S8};

  &:hover {
    background-color: ${Color.Grey50};
  }
`
